<template>
  <a-tooltip :title="$t('分组')">
    <a-popover
      title=""
      trigger="click"
      placement="bottom"
    >
      <template #content>
        <div v-if="selectedConditionGroup">
          <a-menu>
            <a-menu-item @click="handleClearConditionGroup">
              {{ $t('取消分组') }}
            </a-menu-item>
          </a-menu>
        </div>
        <a-input
          v-model:value="searchGroupKeyword"
          :allowClear="true"
          :placeholder="$t('搜索...')"
          style="width: 240px; margin-right: 25px"
        >
          <template #prefix>
            <search-outlined />
          </template>
        </a-input>
        <div>
          <a-menu :selectedKeys="selectedKeys">
            <template
              v-for="item in condition_group_config_list_filtered"
              :key="item.field_name"
            >
              <a-menu-item @click="handleSetSelectedConditionGroup(item)">
                {{ $t('按{label}分组', { label: item.label }) }}
              </a-menu-item>
            </template>
          </a-menu>
        </div>
      </template>
      <group-outlined :style="selectedConditionGroup ? 'color: #1890ff' : ''" />
    </a-popover>
  </a-tooltip>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue';
import { ConditionGroupConfigItem, Table } from './typing';

interface Props {
  config: Table;
  selfEventBus: any;
}
const props = withDefaults(defineProps<Props>(), {
  config: null,
});
const emit = defineEmits(['change']);
const selectedConditionGroup = defineModel('selectedConditionGroup', {
  default: null,
});
const groupConditionValue = defineModel('groupConditionValue', {
  default: null,
});
const searchGroupKeyword = ref('');
const condition_group_config_list_filtered = computed(() => {
  return props.config?.condition_group_config_list?.filter(item => {
    return item.label.includes(searchGroupKeyword.value);
  });
});
const selectedKeys = computed(() => {
  return selectedConditionGroup.value?.field_name ? [selectedConditionGroup.value.field_name] : [];
});

const handleClearConditionGroup = () => {
  groupConditionValue.value = null;
  selectedConditionGroup.value = null;
  emit('change', selectedConditionGroup.value);
  props.selfEventBus.emit('refresh');
};
const handleSetSelectedConditionGroup = (item: ConditionGroupConfigItem) => {
  groupConditionValue.value = null;
  selectedConditionGroup.value = item;
  emit('change', selectedConditionGroup.value);
  props.selfEventBus.emit('refresh');
};
</script>
